import { z } from 'zod';

export const MessageType = z.enum([
  'hide-fic',
  'hide-fic-transition-complete',
  'hide-support-window',
  'hide-support-window-transition-complete',
  'show-fic',
  'show-fic-transition-complete',
  'show-support-window',
  'show-support-window-transition-complete',
  'show-hidden',
  'show-hidden-transition-complete',
  'simplr-initiate-chat',
  'transition-to-fic',
  'transition-to-support-window',
  'hide-fab',
  'hide-fab-transition-complete',
  'show-fab',
  'show-fab-transition-complete',
  'transition-to-fab',
  'fic-input-focused',
]);
